import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_KEYS, CLIENT_STATE_VERSIONS, DEFAULT_PERCENTAGE_FORMAT, } from '../../client-state-type';
import { ClientStateV2Class, ClientStateV2Schema } from '../types/v2';
import { isStackedChart } from './common-util';
const upgradeV2toV2dot1 = (clientState, vizModel) => {
    const updatedClientState = _.cloneDeep(clientState);
    if (isStackedChart(vizModel.chartType) &&
        !!_.get(clientState, CLIENT_STATE_KEYS.IS_STACKED_AS_PERCENT)) {
        _.set(updatedClientState, [
            CLIENT_STATE_KEYS.chartProperties,
            CLIENT_STATE_KEYS.chartSpecific,
            CLIENT_STATE_KEYS.isStackedAsPercent,
        ], true);
        if (!_.get(updatedClientState, [
            CLIENT_STATE_KEYS.chartProperties,
            CLIENT_STATE_KEYS.chartSpecific,
            CLIENT_STATE_KEYS.stackedAsPercentFormat,
        ])) {
            _.set(updatedClientState, [
                CLIENT_STATE_KEYS.chartProperties,
                CLIENT_STATE_KEYS.chartSpecific,
                CLIENT_STATE_KEYS.stackedAsPercentFormat,
            ], DEFAULT_PERCENTAGE_FORMAT);
        }
    }
    const newClientState = {
        ...updatedClientState,
        [CLIENT_STATE_KEYS.version]: CLIENT_STATE_VERSIONS.V2dot1,
    };
    const clientStateV2 = new ClientStateV2Class();
    _.assign(clientStateV2, newClientState);
    return clientStateV2;
};
const upgraderFn = (clientState, vizModel) => {
    Joi.assert(clientState, ClientStateV2Schema);
    const clientStateVersion = _.get(clientState, CLIENT_STATE_KEYS.version);
    if (clientStateVersion !== CLIENT_STATE_VERSIONS.V2) {
        throw new Error(`incompatible client state received in chart upgrade path for v2 to v2.1 with version no:${clientStateVersion}`);
    }
    return upgradeV2toV2dot1(clientState, vizModel);
};
const testHooks = {
    upgradeV2toV2dot1,
};
export { upgraderFn, testHooks };
//# sourceMappingURL=v2-to-v2dot1.js.map